export const swap2MinMax = (n1: number, n2: number): [min: number, max: number] => [
  Math.min(n1, n2),
  Math.max(n1, n2),
];
